import { Dialogue, SharedDialogue } from "../domain/backend/models/dialogue";

export function isSharedDialogue(
  dialogue?: SharedDialogue | Dialogue
): dialogue is SharedDialogue {
  return !!(dialogue as SharedDialogue)?.dialogueOne;
}
